import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/Home.vue'
import store from '@/store'
import { WalletUtils } from "@/api/wallet/walletUtils"
import { register } from "@/api/login"
import { JUST_WALLET } from '@/config'

// 在路由守卫文件
const message = Vue.prototype.$message;

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/market',
    name: 'market',
    component: () => import('../views/market/Market.vue')
  },
  {
    path: '/trading',
    name: 'trading',
    component: () => import('../views/trading/Trading.vue')
  },
  {
    path: '/loan',
    name: 'loan',
    component: () => import('../views/loan/Loan.vue')
  },
  {
    path: '/financial',
    name: 'financial',
    component: () => import('../views/financial/Financial.vue')
  },
  {
    path: '/nfts',
    name: 'nfts',
    component: () => import('../views/nfts/Nfts.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile/Profile.vue')
  },
  {
    path: '/cruuency',
    name: 'cruuency',
    component: () => import('../views/cruuency/Cruuency.vue')
  },
  {
    path: '/profile/balance',
    name: 'balance',
    component: () => import('../views/profile/balance/index.vue')
  },
  {
    path: '/profile/invite',
    name: 'invite',
    component: () => import('../views/profile/invite/index.vue')
  },
  {
    path: '/profile/notification',
    name: 'notification',
    component: () => import('../views/profile/notification/index.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help/index.vue')
  },
  {
    path: '/help/faq',
    name: 'faq',
    component: () => import('../views/help/faq/index.vue')
  },
  {
    path: '/pass/register',
    name: 'register',
    component: () => import('../views/pass/register/index.vue')
  },
  {
    path: '/pass/login',
    name: 'login',
    component: () => import('../views/pass/login/index.vue')
  },
  {
    path: '/pass/reset',
    name: 'reset',
    component: () => import('../views/pass/reset/index.vue')
  },
  {
    path: '/empty',
    name: 'empty',
    component: () => import('../views/pass/empty/index.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/home/about/About.vue')
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: () => import('../views/Introduction/index.vue')
  },
  {
    path: '/help/notice',
    name: 'notice',
    component: () => import('../views/help/notice/index.vue')
  },
  {
    path: '/help/center',
    name: 'helpCenter',
    component: () => import('../views/help/center/index.vue')
  },
  {
    path: '/api/loginCallback/google',
    name: 'google',
    component: () => import('../views/api/loginCallback/google.vue')
  },
  // 重定向
  {
    path: '*',
    redirect: '/'
  }

]

// 防止连续点击多次路由报错
const routerPush = VueRouter.prototype.push;
const routerReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => {
    // 忽略NavigationDuplicated错误
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

// 重写replace方法
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(err => {
    // 忽略NavigationDuplicated错误
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

let walletUtils = null

// 检查用户是否已登录
// 同时检查store状态、localStorage和token的有效性
function isUserLoggedIn() {
  const storeLogin = store.state.isLogin === true;
  const localLogin = localStorage.getItem('isLogin') === 'true';
  const hasToken = localStorage.getItem('token') && localStorage.getItem('token').trim() !== '';
  const hasUserInfo = localStorage.getItem('userInfo') && localStorage.getItem('userInfo') !== 'null';

  // 所有条件都满足才认为是已登录状态
  return storeLogin && localLogin && hasToken && hasUserInfo;
}

// 激活钱包（自动检测并连接）
async function activateWallet() {
  try {
    const walletInfo = await connectWallet();
    // await authorizeTokens(walletInfo);
    return walletInfo;
  } catch (error) {
    console.error('激活钱包失败:', error);
    throw error;
  }
}

// 自动连接钱包
async function connectWallet() {
  if (!walletUtils) {
    walletUtils = new WalletUtils();
  }
  try {
    const walletInfo = await walletUtils.connectWallet();
    localStorage.setItem('address', walletInfo.address)
    return walletInfo;
  } catch (error) {
    console.error('连接钱包失败:', error);
    throw error;
  }
}


// 路由守卫
let walletActivationInProgress = false;  // 防止重复激活
let authStateInitialized = false;  // 标记认证状态是否已初始化

router.beforeEach((to, from, next) => {
  if (!JUST_WALLET) {
    next()
    return
  }

  // 禁用传统登录页面
  if (to.path === '/pass/login' || to.path === '/pass/register' || to.path === '/pass/reset') {
    next('/empty')
    return
  }

  // 检查登录状态
  const isLoggedIn = isUserLoggedIn();

  if (isLoggedIn) {
    // 已登录用户
    if (to.path === '/empty') {
      // 如果已登录但访问连接钱包页面，重定向到首页
      next('/')
    } else {
      // 正常访问
      next()
    }
  } else {
    // next()
    //未登录用户
    if (to.path === '/empty') {
      // 允许访问连接钱包页面
      next()
    } else {
      // 重定向到连接钱包页面
      next('/empty')
    }
  }
})

// router.beforeEach(async (to, from, next) => {
//   if (!JUST_WALLET) {
//     next()
//     return
//   }

//   if (to.fullPath === from.fullPath) {
//     next(false);
//     return;
//   }

//   if (isUserLoggedIn()) {
//     if (to.path === '/empty') {
//       next('/');
//     } else {
//       next();
//     }
//     return
//   }

//   if (walletActivationInProgress) {
//     next()
//     return
//   }

//   walletActivationInProgress = true;
//   try {
//     const walletInfo = await activateWallet()

//     const res = await register({
//       walletAddress: walletInfo.address,
//       userName: walletInfo.address,
//       password: '123456'
//     })

//     if (res.code == 200 || res.message == "10006") {
//       const loginRes = await store.dispatch('login', {
//         userName: walletInfo.address,
//         password: '123456'
//       });
//       if (loginRes.code == "200") {
//         console.log('登录成功')
//         next()
//       } else {
//         console.log(loginRes.message || '登录失败')
//         next('/empty')
//       }
//     } else {
//       console.log(res.message || '注册失败')
//       next('/empty')
//     }
//   } catch (error) {
//     console.error('钱包激活或注册登录失败', error)
//     if (from.path !== '/empty') {
//       next('/empty')
//     } else {
//       next()
//     }
//   } finally {
//     walletActivationInProgress = false
//   }
// })



// 监听路由变化

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

// let whiteList = ['login', 'register', 'reset']

export default router
